namespace Gamification.Gamification {
    export interface UtentiDelegatiRow {
        IdUtenteDelegato?: number;
        UserId?: number;
        UserIdDelDelegato?: number;
        UserIdDelDelegatoUsername?: string;
        UserIdDelDelegatoDisplayName?: string;
        UserIdDelDelegatoEmail?: string;
        UserIdDelDelegatoSource?: string;
        UserIdDelDelegatoLastDirectoryUpdate?: string;
        UserIdDelDelegatoUserImage?: string;
        UserIdDelDelegatoInsertDate?: string;
        UserIdDelDelegatoInsertUserId?: number;
        UserIdDelDelegatoUpdateDate?: string;
        UserIdDelDelegatoUpdateUserId?: number;
        UserIdDelDelegatoIsActive?: number;
        UserIdDelDelegatoMobilePhoneNumber?: string;
        UserIdDelDelegatoMobilePhoneVerified?: boolean;
        UserIdDelDelegatoTwoFactorAuth?: number;
        UserIdDelDelegatoCognome?: string;
        UserIdDelDelegatoNome?: string;
    }

    export namespace UtentiDelegatiRow {
        export const idProperty = 'IdUtenteDelegato';
        export const localTextPrefix = 'Gamification.UtentiDelegati';
        export const lookupKey = 'Gamification.UtentiDelegati';

        export function getLookup(): Q.Lookup<UtentiDelegatiRow> {
            return Q.getLookup<UtentiDelegatiRow>('Gamification.UtentiDelegati');
        }
        export const deletePermission = 'Gamification:Utenti';
        export const insertPermission = 'Gamification:Utenti';
        export const readPermission = 'Gamification:Utenti';
        export const updatePermission = 'Gamification:Utenti';

        export declare const enum Fields {
            IdUtenteDelegato = "IdUtenteDelegato",
            UserId = "UserId",
            UserIdDelDelegato = "UserIdDelDelegato",
            UserIdDelDelegatoUsername = "UserIdDelDelegatoUsername",
            UserIdDelDelegatoDisplayName = "UserIdDelDelegatoDisplayName",
            UserIdDelDelegatoEmail = "UserIdDelDelegatoEmail",
            UserIdDelDelegatoSource = "UserIdDelDelegatoSource",
            UserIdDelDelegatoLastDirectoryUpdate = "UserIdDelDelegatoLastDirectoryUpdate",
            UserIdDelDelegatoUserImage = "UserIdDelDelegatoUserImage",
            UserIdDelDelegatoInsertDate = "UserIdDelDelegatoInsertDate",
            UserIdDelDelegatoInsertUserId = "UserIdDelDelegatoInsertUserId",
            UserIdDelDelegatoUpdateDate = "UserIdDelDelegatoUpdateDate",
            UserIdDelDelegatoUpdateUserId = "UserIdDelDelegatoUpdateUserId",
            UserIdDelDelegatoIsActive = "UserIdDelDelegatoIsActive",
            UserIdDelDelegatoMobilePhoneNumber = "UserIdDelDelegatoMobilePhoneNumber",
            UserIdDelDelegatoMobilePhoneVerified = "UserIdDelDelegatoMobilePhoneVerified",
            UserIdDelDelegatoTwoFactorAuth = "UserIdDelDelegatoTwoFactorAuth",
            UserIdDelDelegatoCognome = "UserIdDelDelegatoCognome",
            UserIdDelDelegatoNome = "UserIdDelDelegatoNome"
        }
    }
}
